<template>
  <module-page v-bind="pageParams">
    <v-layout row wrap v-for="discount in discountList" :key="discount._id">
      <v-flex xs12>
        <v-card class="discount_list__card" outlined tile>
          <div class="discount_list__card-container">
            <a @click="openLink(discount)">
              <v-layout column align-center>
                <v-img
                  class="discount_list__img-container"
                  :src="discount.thumbnail"
                  aspect-ratio="1.76"
                >
                </v-img>
                <h3 class="my-1 enterprise--color">Veja os descontos</h3>
              </v-layout>
            </a>
            <div class="discount_list__card-container-description">
              <div class="discount_list__card-container-title">
                <h2>
                  <span v-if="discount.showTitle">{{ discount.title }}</span>
                </h2>
              </div>
              <p>{{ discount.description }}</p>
            </div>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </module-page>
</template>

<script>
import moment from 'moment-timezone';
import ModulePage from '@/components/layout/Page';
import ScreenLoading from '@/components/loaders/ScreenLoading';
import { APP, UNIT } from '../../utils/constants';

export default {
  name: 'discounts-list',
  components: {
    ModulePage,
    ScreenLoading,
  },
  computed: {
    discountList() {
      return this.$store.getters[UNIT.GET_DISCOUNT_LIST];
    },
  },
  filters: {
    parseDate(v) {
      return moment(v).format('DD/MM/YYYY');
    },
  },
  data() {
    return {};
  },
  created() {
    this.pageParams = this.$store.getters[APP.PAGES].discountList;
  },
  beforeDestroy() {},
  methods: {
    openLink(discount) {
      const title = discount.title;
      const attachment = discount.link;
      window.open(attachment);

      this.createTrace(this.enums.logTraceActions.discountLink, {
        title,
        attachment,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/breakpoint';

.discount_list {
  @include breakpoint(mobile) {
    &__card-container {
      flex-direction: column;
    }

    &__card-container-description {
      width: auto !important;
      padding: 12px !important;
    }
  }

  &__card {
    margin: 6px 0;
  }
  &__card-container {
    display: flex;
    padding: 1em;
  }

  &__card-container-description {
    padding: 12px;
    padding-top: 2.5em;
    padding-bottom: 2.5em;
    width: calc(100% - 320px);
  }

  &__card-container-title {
    h2 {
      display: inline-block;
    }
    span {
      float: right;
    }
  }

  &__img-container {
    min-width: 318px;
    min-height: 160px;

    &:hover {
      opacity: 0.5;
      cursor: pointer;
    }

    .play {
      position: relative;
      top: 50%;
      left: 50%;
      width: 80px;
      height: 80px;
      margin: -40px 0 0 -40px;
    }
  }

  &__video-container {
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;
    max-width: 100%;

    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/product/DiscountList.vue